export default "__VITE_ASSET__DOOhYtDp__"